import { getUpcomingMeetings } from 'store/chat/services/getUpcomingMeetings.service';
import { reconcileUpcomingMeetings } from '../slices/chatSlice';

// Reminders fire 15 min before a meeting, so a 48-hour look-ahead is plenty and
// keeps the fetch cheap even when open-ended series have materialized dozens of
// future occurrences per thread.
const REMINDER_HORIZON_HOURS = 48;

// The API reads at most this many thread ids per call (MAX_THREADS in
// get-upcoming-meetings) and silently drops the rest, so a user in many
// projects lost reminders for whichever threads sorted last.
export const MAX_THREADS_PER_REQUEST = 250;

/**
 * Seed the reminder scheduler with the user's upcoming meetings across the
 * threads it knows, one call per batch the API will read in full. Each answer
 * merges into the per-thread store and drops meetings it shows are gone from
 * the threads it read (see reconcileUpcomingMeetings), so batches never touch
 * each other's meetings — an API without coverage only merges.
 */
export const fetchUpcomingMeetings = (threadIds) => async (dispatch) => {
  const ids = Array.from(new Set((threadIds || []).filter(Boolean)));
  const batches = [];
  for (let i = 0; i < ids.length; i += MAX_THREADS_PER_REQUEST) {
    batches.push(ids.slice(i, i + MAX_THREADS_PER_REQUEST));
  }

  await Promise.all(
    batches.map(async (batch) => {
      try {
        const response = await getUpcomingMeetings(batch, {
          withinHours: REMINDER_HORIZON_HOURS,
        });
        const answer = Array.isArray(response)
          ? { meetings: response, coverage: null }
          : response;
        if (!Array.isArray(answer?.meetings)) return;
        dispatch(reconcileUpcomingMeetings(answer));
      } catch {
        // Reminders are best-effort; a failed batch just means none for its
        // threads this cycle.
      }
    })
  );
};
